/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/billingaddress';

/**
 * setBillingAddress
 * url - /checkout/{apiversion}/cart/{cartId}/billingaddress?brand={brandId}
 *
 * @param {Object} wcEnv
 * @param {String} jwtToken
 * @param {String} cartId
 * @param {String} sourceApp
 * @param {object} customer
 */
const setBillingAddress = ({
    env, jwtToken, cartId, sourceApp, customer,
}) => {
    const envObj = env || {};
    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const payload = {
        sourceApp,
        customer,
    };
    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;

    return restClient.putRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default setBillingAddress;
